
import { format } from "date-fns";
import { TableCell, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { UserAvatar } from "./UserAvatar";
import { UserActionsMenu } from "./UserActionsMenu";

interface AdminUser {
  id: string;
  email?: string;
  full_name?: string;
  avatar_url?: string;
  created_at?: string;
  roles?: string[];
  login_count?: number;
}

interface UserRowProps {
  user: AdminUser;
  onUserUpdated: () => void;
}

// Function to get badge variant for different roles
const getRoleBadgeVariant = (role: string) => {
  switch (role) {
    case 'admin':
      return 'destructive';
    case 'sales_assistant':
      return 'secondary';
    case 'atc':
      return 'outline';
    case 'dm':
      return 'secondary';
    default:
      return 'outline';
  }
};

export const UserRow = ({ user, onUserUpdated }: UserRowProps) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'MMM d, yyyy');
    } catch (error) {
      return 'Invalid date';
    }
  };
  
  return (
    <TableRow>
      <TableCell className="font-medium">
        <div className="flex items-center gap-2">
          <UserAvatar 
            fullName={user.full_name} 
            email={user.email} 
          />
          <span>{user.full_name || 'Unnamed User'}</span>
        </div>
      </TableCell>
      <TableCell>{user.email || 'No email'}</TableCell>
      <TableCell>
        <div className="flex flex-wrap gap-1">
          {user.roles && user.roles.length > 0 ? (
            user.roles.map((role, idx) => (
              <Badge 
                key={`${user.id}-${role}-${idx}`} 
                variant={getRoleBadgeVariant(role)}
                className="capitalize"
              >
                {role}
              </Badge>
            ))
          ) : (
            <Badge variant="outline">User</Badge>
          )}
        </div>
      </TableCell>
      <TableCell>{user.login_count || 0}</TableCell>
      <TableCell>{formatDate(user.created_at)}</TableCell>
      <TableCell>
        <UserActionsMenu user={user} onUserUpdated={onUserUpdated} />
      </TableCell>
    </TableRow>
  );
};
